import { toEhashAsync } from "./helpers/helpers";

window.toEhashAsync = toEhashAsync;

// Send Track To Parent
const triggerDataLayerEvent = (eventName, eventData = {}) => {
  const event = new CustomEvent(eventName, {
    detail: eventData,
  });
  document.dispatchEvent(event);
};

window.triggerDataLayerEvent = triggerDataLayerEvent;

const postEventToParent = (eventKey, eventData, messageKey = "wvusDataLayerEvent") => {
  const message = {
    messageKey,
    eventKey,
    eventData
  };

  if (window?.parent?.postMessage && window.parent !== window) {
    window.parent.postMessage(message, "*");
  } else {
    triggerDataLayerEvent(eventKey, eventData);
  }
}

window.postEventToParent = postEventToParent;

const listenPostEventToParent = (messageKey = "wvusDataLayerEvent") => {
  const eventToParentListener = (event) => {
    if (event?.data?.messageKey === messageKey && /worldvision.org$/.test(event.origin)) {
      const { eventKey, eventData } = event?.data || {};
      triggerDataLayerEvent(eventKey, eventData);
    }
  };

  window.addEventListener("message", eventToParentListener);

  return {
    unsubscribe() {
      window.removeEventListener("message", eventToParentListener);
    }
  }
}

window.listenPostEventToParent = listenPostEventToParent;

export { postEventToParent, listenPostEventToParent, triggerDataLayerEvent };